import React, { useEffect, useState } from "react";
import { string } from "prop-types";

import { appDownloadLinks, getStorage, setStorage } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";
import { APP_PROMPT_RESET_INTERVAL } from "../../utils/constant";

import CloseIcon from "../../atoms/icons/close";
import Icon from "../../../components/icons";

import "./app-open-prompt.m.css";

const LAST_SHOWN_KEY = "prothomalo-app-prompt-last-shown";

const isWebView = (userAgent) =>
  /; wv\)/i.test(userAgent) || /iP(hone|ad|od).*AppleWebKit(?!.*Safari)/i.test(userAgent);

const AppOpenPrompt = ({ lang, domainSlug }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const userAgent = global.navigator.userAgent;
    const lastShown = getStorage(LAST_SHOWN_KEY);
    const now = Date.now();
    if (
      global.isMobile &&
      !isWebView(userAgent) &&
      (!Number.isFinite(lastShown) || now - lastShown >= APP_PROMPT_RESET_INTERVAL)
    ) {
      setIsVisible(true);
    }
  }, []);

  const dismissPrompt = () => {
    const now = Date.now();
    setStorage(LAST_SHOWN_KEY, now);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  const translations = staticTexts(lang);
  const userAgent = global.navigator.userAgent;
  const isAndroid = /Android/i.test(userAgent);
  const isAppleDevice = /(iPhone|iPad|iPod)/i.test(userAgent);
  const appStoreUrl = appDownloadLinks(lang, isAppleDevice ? "apple" : "google", domainSlug);
  const { host, pathname, search, hash } = global.location;
  const currentPage = [host, pathname, search, hash].join("");
  const appPackage = lang === "bn" ? "com.mcc.prothomalo" : "com.prothomalo.english";
  const appLink = isAndroid
    ? `intent://${currentPage}#Intent;scheme=https;package=${appPackage};S.browser_fallback_url=${encodeURIComponent(
        appStoreUrl
      )};end`
    : appStoreUrl;

  if (!isAndroid && !isAppleDevice) return null;

  return (
    <div styleName="overlay">
      <div styleName="close-button" onClick={dismissPrompt}>
        <CloseIcon color="#fff" height="16" width="16" />
      </div>

      <div styleName="dialog" role="dialog" aria-modal="true" aria-label={translations.appPromptMessage}>
        <div styleName="prompt-sun-icon">
          <Icon styleName="prompt-sun-icon" type="sun" />
        </div>
        <div styleName="prompt-message">
          <p styleName="message">{translations.appPromptMessage}</p>
          <p styleName="subtitle">{translations.appPromptSubtitle}</p>
        </div>
        <div styleName="action-button">
          <a href={appLink} target="_blank" rel="noopener noreferrer" styleName="app-link" onClick={dismissPrompt}>
            {translations.continueInApp}
          </a>
        </div>
      </div>
    </div>
  );
};

AppOpenPrompt.propTypes = {
  lang: string,
  domainSlug: string,
};

export default AppOpenPrompt;
